import React, { useState } from 'react';

interface Props {
  quantidadeSelecionada: number;
  aplicando: boolean;
  onCancelar: () => void;
  onConfirmar: (dados: { dataPrevistaEnvio?: string; prazoResposta?: string }) => void;
}

// Seção 7.1 — "Aplicar um prazo a várias empresas" de uma vez.
const PlanejamentoLoteModal: React.FC<Props> = ({ quantidadeSelecionada, aplicando, onCancelar, onConfirmar }) => {
  const [dataPrevistaEnvio, setDataPrevistaEnvio] = useState('');
  const [prazoResposta, setPrazoResposta] = useState('');
  const [erro, setErro] = useState<string | undefined>();

  const confirmar = () => {
    if (dataPrevistaEnvio && prazoResposta && prazoResposta < dataPrevistaEnvio) {
      setErro('O prazo para resposta não pode ser anterior à data prevista de envio.');
      return;
    }
    if (!dataPrevistaEnvio && !prazoResposta) {
      setErro('Informe ao menos uma data para aplicar em lote.');
      return;
    }
    setErro(undefined);
    onConfirmar({ dataPrevistaEnvio: dataPrevistaEnvio || undefined, prazoResposta: prazoResposta || undefined });
  };

  return (
    <div className='circ-modal-backdrop' onMouseDown={(e) => e.target === e.currentTarget && onCancelar()}>
      <div className='circ-modal' style={{ maxWidth: 460 }}>
        <div className='circ-modal-header'>
          <h4>Aplicar Prazo em Lote</h4>
          <button type='button' className='btn btn-sm btn-icon btn-light' aria-label='Fechar' onClick={onCancelar}>
            <i className='bi bi-x-lg' />
          </button>
        </div>
        <div className='circ-modal-body'>
          <p style={{ fontSize: 13 }}>
            Será aplicado a <strong>{quantidadeSelecionada}</strong> empresa{quantidadeSelecionada === 1 ? '' : 's'}{' '}
            selecionada{quantidadeSelecionada === 1 ? '' : 's'}.
          </p>
          <div className='circ-form-group'>
            <label>Data Prevista de Envio</label>
            <input type='date' className='circ-form-control' value={dataPrevistaEnvio} onChange={(e) => setDataPrevistaEnvio(e.target.value)} />
          </div>
          <div className='circ-form-group'>
            <label>Prazo para Resposta</label>
            <input type='date' className='circ-form-control' value={prazoResposta} onChange={(e) => setPrazoResposta(e.target.value)} />
          </div>
          {erro && <div className='text-danger' style={{ fontSize: 12 }}>{erro}</div>}
        </div>
        <div className='circ-modal-footer'>
          <button type='button' className='btn btn-sm btn-light' disabled={aplicando} onClick={onCancelar}>
            Cancelar
          </button>
          <button type='button' className='btn btn-sm btn-primary' disabled={aplicando} onClick={confirmar}>
            {aplicando && <span className='spinner-border spinner-border-sm me-1' />}
            Aplicar a Selecionadas
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlanejamentoLoteModal;
